/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAtsAutomationSettingsShow } from '../../axios/organisationAtsAutomationSettingsShow'
import type {
	OrganisationAtsAutomationSettingsShowError,
	OrganisationAtsAutomationSettingsShowPathParams,
	OrganisationAtsAutomationSettingsShowResponse,
} from '../../types/OrganisationAtsAutomationSettingsShow'

export const organisationAtsAutomationSettingsShowQueryKey = (
	organisation: OrganisationAtsAutomationSettingsShowPathParams['organisation'],
) => [{ url: '/organisations/:organisation/ats-automation-settings', params: { organisation } }] as const

export type OrganisationAtsAutomationSettingsShowQueryKey = ReturnType<
	typeof organisationAtsAutomationSettingsShowQueryKey
>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::show */
export function organisationAtsAutomationSettingsShowQueryOptions(
	organisation: OrganisationAtsAutomationSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationAtsAutomationSettingsShowResponse,
		AxiosError<OrganisationAtsAutomationSettingsShowError>,
		OrganisationAtsAutomationSettingsShowResponse,
		OrganisationAtsAutomationSettingsShowQueryKey
	>({
		queryKey: organisationAtsAutomationSettingsShowQueryKey(organisation),
		queryFn: ({ signal }) =>
			organisationAtsAutomationSettingsShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::show */
export function useOrganisationAtsAutomationSettingsShow<TSelectData = OrganisationAtsAutomationSettingsShowResponse>(
	organisation: OrganisationAtsAutomationSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationAtsAutomationSettingsShowResponse,
					AxiosError<OrganisationAtsAutomationSettingsShowError>,
					TSelectData,
					OrganisationAtsAutomationSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationAtsAutomationSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationAtsAutomationSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::show */
export function useOrganisationAtsAutomationSettingsShowSuspense<
	TSelectData = OrganisationAtsAutomationSettingsShowResponse,
>(
	organisation: OrganisationAtsAutomationSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationAtsAutomationSettingsShowResponse,
					AxiosError<OrganisationAtsAutomationSettingsShowError>,
					TSelectData,
					OrganisationAtsAutomationSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationAtsAutomationSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationAtsAutomationSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
